<template>
  <div class="main-menu">
    <Disclosure as="nav" class="bg-gradient-to-r from-gray-500 via-green-400 to-green-800 relative" v-slot="{ open }">
      <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div class="flex h-16 items-center justify-between">
          <div class="flex items-center">
            <div class="flex-shrink-0">
              <router-link to="/inicio">
                <img
                    :src="assetUrl('assets/img/escudogobe.png')"
                    class="h-8 mr-1 sm:h-14"
                    alt="Logo de la Gobernación del Tolima"
                />
              </router-link>
            </div>
            <div class="hidden lg:block">
              <div class="ml-10 flex items-baseline space-x-4">
                <router-link
                    v-for="(item, index) in menuPrincipal"
                    :key="index"
                    :to="{name:item.name}"
                    :class="[
                      menuPrincipalSeleccionado===item.name
                        ? 'bg-gray-900 text-white':'text-white hover:bg-gray-700 hover:text-white','px-3 py-2 rounded-md text-sm font-medium',]" :aria-current="menuPrincipalSeleccionado===item.name?'page':''">
                    {{ item.alias }}
                </router-link>
              </div>
            </div>
          </div>
          <div class="hidden lg:block">
            <div class="ml-4 flex items-center md:ml-6">
              <!-- Profile dropdown -->
              <div class="ml-3" v-if="authUser">
                <div class="text-base font-medium leading-none text-white text-right">
                  {{ authUser.usuario }}
                </div>
                <div class="text-sm font-medium leading-none text-gray-400">
                  {{ authUser.email }}
                </div>
              </div>
              <Menu as="div" class="relative ml-3">
                <div>
                  <MenuButton
                      class="
                        flex
                        max-w-xs
                        items-center
                        rounded-full
                        bg-white
                        text-sm
                        focus:outline-none
                        focus:ring-2
                        focus:ring-white
                        focus:ring-offset-2
                        focus:ring-offset-gray-800
                      "
                  >
                    <span class="sr-only">Abrir el menú del usuario</span>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="w-6 h-6"
                    >
                      <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z"
                      />
                    </svg>
                  </MenuButton>
                </div>
                <transition
                    enter-active-class="transition ease-out duration-100"
                    enter-from-class="transform opacity-0 scale-95"
                    enter-to-class="transform opacity-100 scale-100"
                    leave-active-class="transition ease-in duration-75"
                    leave-from-class="transform opacity-100 scale-100"
                    leave-to-class="transform opacity-0 scale-95"
                >
                  <MenuItems
                      class="
                        absolute
                        right-0
                        z-10
                        mt-2
                        w-48
                        origin-top-right
                        rounded-md
                        bg-white
                        py-1
                        shadow-lg
                        ring-1 ring-black ring-opacity-5
                        focus:outline-none
                      "
                  >
                    <MenuItem @click="irAModulo('Perfil')">
                      <button class="block px-4 py-2 w-full text-left text-sm text-gray-700">Perfil</button>
                    </MenuItem>
                    <hr>
                    <MenuItem @click="logout">
                      <button class="block px-4 py-2 w-full text-left text-sm text-gray-700">Cerrar Sesión</button>
                    </MenuItem>
                  </MenuItems>
                </transition>
              </Menu>
            </div>
          </div>
          <div class="-mr-2 flex lg:hidden">
            <!-- Mobile menu button -->
            <DisclosureButton
                class="
                  inline-flex
                  items-center
                  justify-center
                  rounded-md
                  bg-gray-800
                  p-2
                  text-gray-400
                  hover:bg-gray-700 hover:text-white
                  focus:outline-none
                  focus:ring-2
                  focus:ring-white
                  focus:ring-offset-2
                  focus:ring-offset-gray-800
                "
            >
              <span class="sr-only">Abrir menú principal</span>
              <Bars3Icon
                  v-if="!open"
                  class="block h-6 w-6"
                  aria-hidden="true"
              />
              <XMarkIcon v-else class="block h-6 w-6" aria-hidden="true"/>
            </DisclosureButton>
          </div>
        </div>
      </div>

      <DisclosurePanel class="lg:hidden">
        <div class="space-y-1 px-2 pt-2 pb-3 sm:px-3">
          <DisclosureButton
              v-for="(item, index) in menuPrincipal"
              @click="irAModulo(item.name)"
              :key="'A'+index"
              :class="[
                (menuPrincipalSeleccionado===item.name
                  ? 'bg-gray-900 text-white '
                  : 'text-gray-300 hover:bg-gray-700 hover:text-white ')+
                'block px-3 py-2 rounded-md text-base font-medium w-full',
              ]"
              :aria-current="menuPrincipalSeleccionado===item.name ? 'page' : ''"
          >{{ item.alias }}
          </DisclosureButton>
        </div>
        <div class="border-t border-white pt-4 pb-3">
          <div class="flex items-center px-5 text-white">
            <div class="flex-shrink-0">
              <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="w-6 h-6"
              >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z"
                />
              </svg>
            </div>
            <div class="ml-3">
              <div class="text-base font-medium leading-none text-white">
                {{ authUser.usuario }}
              </div>
              <div class="text-sm font-medium leading-none text-gray-400">
                {{ authUser.email }}
              </div>
            </div>
          </div>
          <div class="mt-3 space-y-1 px-2">
            <DisclosureButton
                @click="irAModulo('Perfil')"
                class="
                          block
                          rounded-md
                          px-3
                          py-2
                          text-base
                          font-medium
                          text-gray-400
                          hover:bg-gray-700 hover:text-white"
            >Perfil
            </DisclosureButton>
          </div>
          <div class="mt-3 space-y-1 px-2">
            <DisclosureButton
                @click="logout"
                class="
                          block
                          rounded-md
                          px-3
                          py-2
                          text-base
                          font-medium
                          text-gray-400
                          hover:bg-gray-700 hover:text-white"
            >Cerrar sesion
            </DisclosureButton>
          </div>
        </div>
      </DisclosurePanel>
    </Disclosure>

  </div>
  <header v-if="menuInferior" class="overflow-auto pb-3">
    <div class="lg:hidden flex flex-column flex-wrap justify-center p-3 gap-3">
      <label for="tabs" class="d-block w-100 font-bold">Menú de {{ modulo }}</label>
      <select id="tabs" autofocus v-model="menuInferiorSeleccionado" @change="irAModulo(menuInferiorSeleccionado)"
              class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
        <option value="">Selecciona una sección...</option>
        <option v-for="(item, index) in menuInferior" :key="'B'+index" :value="item.name">{{ item.alias }}</option>
      </select>
    </div>
    <ul :class="{'hidden': isMobile, 'text-sm': !isMobile, 'mt-5': !isMobile, 'font-medium': !isMobile, 'text-center': !isMobile, 'text-gray-500': !isMobile, 'rounded-lg': !isMobile, 'sm:flex': !isMobile, 'gap-1': !isMobile, 'dark:text-gray-400': !isMobile, 'mt-3': !isMobile, 'mx-3': !isMobile}">
      <li class="basis-[20%] grow" style="min-width: 200px" v-for="(item, index) in menuInferior" :key="'C'+index">
        <router-link :to="{ name: item.name}" 
        :class="'inline-block p-4 w-full shadow '+
             (!index?'rounded-l-lg ':(index+1===menuInferior.length?'rounded-r-lg mr-3 ':''))+
             (menuInferiorSeleccionado===item.name?'text-gray-900 bg-gray-100  focus:ring-4 focus:ring-blue-300 active focus:outline-none dark:bg-gray-700 dark:text-white':
             'bg-white hover:text-gray-700 hover:bg-gray-50 focus:ring-4 focus:ring-blue-300 focus:outline-none dark:hover:text-white dark:bg-gray-800 dark:hover:bg-gray-700')"
          :aria-current="menuInferiorSeleccionado===item.name?'page':''">{{ item.alias }}
        </router-link>
      </li>
    </ul>
  </header>
</template>

<script>
/**
 * Componente que implementa el menú de la aplicación.
 *
 * @vue-prop {Array} modulo - Array de menús inferiores de un módulo
 * @vue-prop {Array} menuInferior - Array de menús inferiores
 *
 * @vue-component
 */
import {Disclosure, DisclosureButton, DisclosurePanel, Menu, MenuButton, MenuItem, MenuItems,} from "@headlessui/vue";
import {Bars3Icon, XMarkIcon} from "@heroicons/vue/24/outline";
import {useAuth} from "@/components/auth/store/composables";
import {useRoute, useRouter} from "vue-router";
import {ref,onMounted, onBeforeUnmount, watch} from 'vue';
import {assetUrl} from "@/common/constants";

export default {
  props: ['modulo', 'menuInferior'],
  name: "MenuComponent",
  methods: {
    assetUrl
  },
  components: {
    Disclosure,
    DisclosureButton,
    DisclosurePanel,
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    Bars3Icon,
    XMarkIcon
  },
  async setup(props) {
    const menuPrincipalSeleccionado = ref('');
    const menuInferiorSeleccionado = ref('');
    const router = useRouter();
    const route = useRoute();
    const {authUser, logoutUser} = useAuth();

    /**
     * Cierra la sesión del usuario y redirige a la página de inicio.
     */
    const logout = () => {
      logoutUser();
      router.push('/');
    };

    /**
     * Redirige al path default del menú principal seleccionado si es necesario.
     * @returns {boolean} - Devuelve true si se redirigió al path default, false en caso contrario.
     */
    const redirigirPathDefault = () => {
      let isPathDefault = false;
      const routeNamePrincipal = route.matched[0]?.name;
      const routeNameInferior = route.matched[1]?.name;
      if (menuPrincipalSeleccionado.value !== routeNamePrincipal ||
          menuInferiorSeleccionado.value !== routeNameInferior) {
        if (props.menuInferior && !menuPrincipalSeleccionado.value) {
          menuInferiorSeleccionado.value = props.menuInferior.filter(infoRoute => infoRoute.current)[0]?.name;
          isPathDefault = true;
        } else if (menuPrincipalSeleccionado.value === routeNamePrincipal && routeNameInferior === undefined) isPathDefault = true;
        else menuInferiorSeleccionado.value = routeNameInferior;
        menuPrincipalSeleccionado.value = routeNamePrincipal;
      }
      return isPathDefault;
    }

    /**
     * Redirige al módulo seleccionado a través del menú.
     * @param {string} menuSeleccionado - Nombre del módulo seleccionado
     */
    const irAModulo = (menuSeleccionado) => {
      for (const route of router.getRoutes()) {
        if (route.name === menuSeleccionado) {
          router.push(route.path);
          break;
        }
      }
    }
    watch(() => route.name, () => {
      if (redirigirPathDefault()) irAModulo(menuInferiorSeleccionado.value);
    });
    if (redirigirPathDefault()) irAModulo(menuInferiorSeleccionado.value);

    /**
     * Carga los principales modulos dependiendo del rol del usuario logeado.
     * @typedef {Object} Menu
     * @property {string} alias - nombre visible del menú
     * @property {string} name - nombre del componente del menú
     * @returns {Array.<Menu>} Array de menus
     */
    const cargarMenuPrincipal = () => {
      let menus = []
      const userStored = JSON.parse(localStorage.getItem("user"));
      //Contiene el id del menú para permisos epecificos y no de un menú en particular
      const idMenuSinComponente = 9;
      
      let newPermisos = userStored.permisosUsuariosEntities.concat(userStored?.rol?.permisosRolesEntities);
      // AGREGAR AQUÍ LOS MÓDULOS QUE SE DESEAN MOSTRAR EN PRODUCCIÓN
      for(let permiso in newPermisos){
        if(newPermisos[permiso].estado 
          && newPermisos[permiso].menu_id != idMenuSinComponente)
        {
          if(newPermisos[permiso].permiso.menu.nivel == 1){
            const result = menus.find(({ name }) => name === newPermisos[permiso].permiso.menu.name);
            if(!result){
              menus.push({
                alias: newPermisos[permiso].permiso.menu.alias, 
                name:  newPermisos[permiso].permiso.menu.name
              });
            }
          }
        }
      }
      // menus.push({alias: "Parametros", name: "MenuParametros"});
      // menus.push({alias: "Rendimientos", name: "MenuRendimientos"});
      // menus.push({alias: "Reservas", name: "MenuReservas"});
      // menus.push({alias: "Embargos", name: "MenuEmbargos"});
      // if(userStored.rol.nombre !== "user")
      //   menus.push({alias: "Administracion", name: "MenuAdministracion"});
      // AGREGAR AQUÍ LOS MÓDULOS QUE TODAVÍA ESTÁN EN DESARROLLO
      // if (process.env.VUE_APP_ENV === 'LOCAL'){
      // }
      return menus
    }

    let menuPrincipal = cargarMenuPrincipal()
    const isMobile = ref(window.innerWidth <= 1023);

    const handleResize = () => {
      isMobile.value = window.innerWidth <= 1023;
    };
    onMounted(() => {
      window.addEventListener('resize', handleResize);
    });

    onBeforeUnmount(() => {
      window.removeEventListener('resize', handleResize);
    });

    return {
      isMobile,
      authUser,
      menuPrincipal,
      menuPrincipalSeleccionado,
      menuInferiorSeleccionado,
      logout,
      redirigirPathDefault,
      irAModulo
    }

    
  }
};
</script>
